/* global process */

export const HCA_SSO_HOSTNAME = "hca.ambifi.com";
export const HCA_SSO_ORG_DOMAIN = "hca";
export const LOCAL_HCA_SSO_ORIGIN = "https://local.ambifi.com:3000";

const BUILD_ENVIRONMENT = process.env.NODE_ENV;
const LOCAL_HCA_SSO_FLAG = process.env.REACT_APP_HCA_LOCAL_SSO;
const LOCAL_HCA_SSO_CLIENT_ID = process.env.REACT_APP_HCA_LOCAL_COGNITO_CLIENT_ID;

function getBrowserLocation() {
	return typeof window !== "undefined" && window.location ? window.location : null;
}

function getRuntimeOption(options, key, fallback) {
	return options && Object.prototype.hasOwnProperty.call(options, key) ? options[key] : fallback;
}

function isEnabledValue(value) {
	if (value === true || value === 1) {
		return true;
	}

	if (typeof value !== "string") {
		return false;
	}

	return ["1", "true", "yes", "on"].includes(value.trim().toLowerCase());
}

function getLocationHostname(location) {
	return location && location.hostname ? `${location.hostname}`.trim().toLowerCase() : "";
}

function getLocationOrigin(location) {
	if (!location) {
		return "";
	}

	if (location.origin) {
		return `${location.origin}`.trim().toLowerCase().replace(/\/$/, "");
	}

	if (location.protocol && location.host) {
		return `${location.protocol}//${location.host}`.trim().toLowerCase().replace(/\/$/, "");
	}

	return "";
}

function getLocalClientId(options) {
	const clientId = getRuntimeOption(options, "clientId", LOCAL_HCA_SSO_CLIENT_ID);
	return typeof clientId === "string" ? clientId.trim() : "";
}

export function isLocalHcaSsoEnabled(location = getBrowserLocation(), options = {}) {
	const environment = getRuntimeOption(options, "environment", BUILD_ENVIRONMENT);
	const enabled = getRuntimeOption(options, "enabled", LOCAL_HCA_SSO_FLAG);
	const clientId = getLocalClientId(options);

	return environment === "development"
		&& isEnabledValue(enabled)
		&& getLocationHostname(location) === "local.ambifi.com"
		&& getLocationOrigin(location) === LOCAL_HCA_SSO_ORIGIN
		&& /^[\w+]{1,128}$/.test(clientId);
}

export function isHcaSsoHost(location = getBrowserLocation(), options = {}) {
	return getLocationHostname(location) === HCA_SSO_HOSTNAME
		|| isLocalHcaSsoEnabled(location, options);
}

export function getHcaSsoAuthSubdomain(location = getBrowserLocation(), options = {}) {
	if (isLocalHcaSsoEnabled(location, options)) {
		return HCA_SSO_ORG_DOMAIN;
	}

	return getLocationHostname(location).split(".")[0];
}

export function applyLocalHcaSsoOverrides(amplifyConfig, location = getBrowserLocation(), options = {}) {
	if (!isLocalHcaSsoEnabled(location, options) || !amplifyConfig || typeof amplifyConfig !== "object") {
		return amplifyConfig;
	}

	return Object.assign({}, amplifyConfig, {
		userPoolWebClientId: getLocalClientId(options),
		oauth: Object.assign({}, amplifyConfig.oauth || {}, {
			redirectSignIn: LOCAL_HCA_SSO_ORIGIN,
			redirectSignOut: LOCAL_HCA_SSO_ORIGIN
		})
	});
}
